import { Fragment } from "react";
import styled from "styled-components/macro";
import { titleCase } from "change-case-all";
import { Info, SyncOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Grid, IconButton, InputAdornment, Tooltip } from "@mui/material";

import {
  TextField,
  ComponentHeader,
  Chip,
  Label,
} from "../../../../components";
import BrandDetailsDialog from "../../brand details components/BrandDetailsDialog";
import { useAxios } from "../../../../hooks";
import { alert } from "../../../../redux/slices/alertSlice";
import { PrimaryLoadingButton } from "../../../css components/Button";
import MuiDateTimePicker from "../../../../components/DateTimePicker";

const ImageDiv = styled.div`
  width: 286px;
  height: 120px;
  border: 1px solid #d6cbcb;
  border-radius: 10px;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: fill;
  border-radius: 10px;
`;
let cpmArray = [
  "CREATED",
  "REQUESTED",
  "OFFER_ACCEPTED",
  "OFFER_REJECTED",
  "PARTIAL_ACCEPTED",
  "PARTIAL_REJECTED",
  "ACCEPTED",
  "REJECTED",
];

export default function FormOne({
  formikProps,
  editState,
  component,
  brandDetails,
  setBrandDetails,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const onImageError = (e) => {
    e.target.src =
      "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png";
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <ComponentHeader
          title="Campaign Details"
          subtitle={
            !formikProps.values.campaignID
              ? "Setup your campaign details"
              : titleCase(formikProps.values?.campaign_name?.value)
          }
          icons={
            formikProps.values.campaignID && [
              formikProps.values.chunkStatus &&
                formikProps.values.campaign_status === "ACTIVE" &&
                component === "superadmin" && (
                  <Tooltip title="Retry">
                    <IconButton
                      onClick={() => handleRetry()}
                      style={{ padding: 0 }}
                    >
                      <SyncOutlined />
                    </IconButton>
                  </Tooltip>
                ),

              component === "" &&
                !cpmArray.includes(formikProps.values.campaign_status) &&
                !cpmArray.includes(formikProps.values.status) && (
                  <Fragment>
                    <Chip
                      font={600}
                      background={siteColors?.primary}
                      color="#fff"
                      label={`Intersection Audience : ${
                        formikProps.values.campaign_status === "INITIATED"
                          ? "Processing..."
                          : formikProps.values.Intersection_Audience
                      } 
                        `}
                    />
                    &nbsp;
                    <Chip
                      font={600}
                      background={siteColors?.primary}
                      color="#fff"
                      label={"Unit Cost of Data : " + formikProps?.values?.cpm}
                    />
                  </Fragment>
                ),
            ]
          }
          buttons={[
            component === "request" && (
              <PrimaryLoadingButton
                onClick={() => {
                  setBrandDetails({
                    ...brandDetails,
                    state: true,
                  });
                }}
                variant="outlined"
              >
                Brand Details
              </PrimaryLoadingButton>
            ),
          ]}
        />
      </Grid>

      {!!formikProps.values.previewImage && (
        <Fragment>
          <Grid item xs={12}>
            <ImageDiv>
              <Image
                src={formikProps.values.previewImage}
                alt="!"
                onError={onImageError}
              />
            </ImageDiv>
          </Grid>
        </Fragment>
      )}

      {(component === "superadmin" || component === "accepted") && (
        <Fragment>
          <Grid item xs={6}>
            <Label title="Brand Name" />

            <TextField
              size="small"
              name="brand_name"
              placeholder="Brand Name"
              disabled={!editState}
              value={brandDetails?.data?.brandName}
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <IconButton
                      onClick={() =>
                        setBrandDetails((prevVal) => ({
                          ...prevVal,
                          state: true,
                        }))
                      }
                      style={{ padding: "0" }}
                    >
                      <Info style={{ color: siteColors?.primary }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Fragment>
      )}

      <Grid item xs={6}>
        <Label
          title="Campaign Name"
          formikProps={formikProps}
          required={true}
          name="campaign_name.value"
        />

        <TextField
          required
          name="campaign_name.value"
          placeholder="Campaign Name"
          formikProps={formikProps}
          disabled={!editState || formikProps.values.campaignStatus === "READY"}
        />
      </Grid>
      {/* added */}
      <Grid item xs={3}>
        <Label
          title="Start Duration"
          formikProps={formikProps}
          required
          name="start_duration.value"
        />

        <MuiDateTimePicker
          disablePast
          name="start_duration.value"
          formikProps={formikProps}
          value={formikProps.values.start_duration.value}
          disabled={!editState}
          required
          minDateTime={new Date()}
          onChange={(newValue) => {
            let updatedValue = newValue;

            const now = new Date();

            if (newValue.getTime() < now.getTime()) {
              updatedValue = new Date(now.getTime() + 5 * 60 * 1000);
            }

            formikProps.setValues((prevVal) => ({
              ...prevVal,
              start_duration: {
                value: updatedValue,
              },
              startTime: {
                value: updatedValue,
              },
            }));
          }}
        />
      </Grid>

      <Grid item xs={3}>
        <Label
          title="End Duration"
          formikProps={formikProps}
          required
          name="end_duration.value"
        />

        <MuiDateTimePicker
          name="end_duration.value"
          formikProps={formikProps}
          value={formikProps.values.end_duration.value}
          disabled={!editState}
          required
          minDateTime={
            formikProps.values.start_duration.value
              ? new Date(
                  new Date(formikProps.values.start_duration.value).getTime() +
                    30 * 60 * 1000
                )
              : new Date()
          }
          onChange={(newValue) => {
            const startDate = new Date(formikProps.values.start_duration.value);

            const minimumEndDate = new Date(
              startDate.getTime() + 30 * 60 * 1000
            );

            const updatedValue =
              newValue.getTime() < minimumEndDate.getTime()
                ? minimumEndDate
                : newValue;

            formikProps.setValues((prevVal) => ({
              ...prevVal,
              end_duration: {
                value: updatedValue,
              },
              endTime: updatedValue,
            }));
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="About Campaign" />

        <TextField
          name="about.value"
          placeholder="About Campaign"
          multiline
          rows={4}
          formikProps={formikProps}
          disabled={!editState || formikProps.values.campaignStatus === "READY"}
        />
      </Grid>

      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );

  function handleRetry() {
    axios({
      url: "/process/failedChunks",
    }).then(function (response) {
      if (response.status) {
        dispatch(
          alert({
            type: "success",
            message: "",
          })
        );
      }
    });
  }
}
